import { auCentime, compteDansLeCa, signeCa, ttcDocument } from './vat';

/**
 * Ce qui a été facturé sur une période, expliqué : les factures datées de la
 * période, puis les acomptes que la comptabilité range dans une autre année.
 *
 * <p>« Toutes mes factures 2026 font 88'470.66, l'accueil dit 77'593.65 » :
 * la différence, ce sont les acomptes touchés en 2025 (7'807 + 3'070), comptés
 * en 2025. L'accueil le dit maintenant ligne par ligne au lieu de le taire.
 *
 * @param {object} p données
 * @param {object[]} p.factures factures de la société, telles qu'émises
 * @param {object[]} p.pieces les mêmes, découpées comme la comptabilité
 *   (piecesComptables) : chaque acompte d'une autre année à part, `partDe`
 * @param {(date: string) => boolean} p.dansLaPeriode dit si une date est dans la période
 * @returns {{nb: number, brutTtc: number,
 *   sortants: {num: string, montant: number}[], entrants: {num: string, montant: number}[]}}
 *   les factures datées de la période (nombre, total TTC, avoirs déduits),
 *   les acomptes de ces factures comptés dans une autre période (sortants), et
 *   ceux d'autres factures comptés dans celle-ci (entrants), TTC
 */
export function factureDeLaPeriode({ factures, pieces, dansLaPeriode }) {
  const dateCa = (f) => f.dateCompta || f.date;
  const originales = (factures || []).filter(compteDansLeCa);
  const parId = new Map(originales.map((f) => [String(f.id), f]));
  const dedans = originales.filter((f) => dansLaPeriode(dateCa(f)));
  const sortants = [];
  const entrants = [];
  (pieces || []).forEach((p) => {
    if (p.partDe == null) return;
    const f = parId.get(String(p.partDe));
    if (!f) return;
    const factureDedans = dansLaPeriode(dateCa(f));
    const acompteDedans = dansLaPeriode(dateCa(p));
    if (factureDedans === acompteDedans) return;
    const ligne = { num: String(f.num || f.id), montant: auCentime(ttcDocument(p)) };
    (factureDedans ? sortants : entrants).push(ligne);
  });
  return {
    nb: dedans.filter((f) => f.type !== 'avoir').length,
    brutTtc: auCentime(dedans.reduce((t, f) => t + signeCa(f) * ttcDocument(f), 0)),
    sortants,
    entrants,
  };
}
